/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useParams } from 'react-router-dom';
import { withGrowl } from '../../components/GrowlNotifications';
import { Loading } from '../../components/Loading';
import {
  growlShape,
} from '../../components/prop-types';
import { growlErrors } from '../../utils/NotificationUtil';

import { withAccount } from '../../components/AccountContext';
import ConsumptionDetail from './ConsumptionDetail';

import { VIEWER_LOCALE } from '../../components/Query';

export const CONSUMPTION_QUERY = gql`
  query ConsumptionQuery($accountId: ID!, $consumptionId: ID!) {
    account(id: $accountId) {
      id
      companyInformation {
        displayName
      }
      consumptionLog(id: $consumptionId) {
        id
        consumedOn
        type
        country
        priceIndex
        basedOn
        consumedBy {
          id
          firstName
          lastName
          email
        }
        items {
          ... on AssessmentConsumption {
            price
            indexedPrice
            item {
              details
              language
            }
          }
          ... on SurveyConsumption {
            price
            indexedPrice
            item {
              details
              language
            }
          }
          ... on MultiAssessmentConsumption {
            price
            indexedPrice
            item {
              details
              language
            }
          }
          ... on MultiSurveyConsumption {
            price
            indexedPrice
            item {
              details
              language
            }
          }
        }
      }
    }
  }
`;

const ConsumptionDetailContainer = ({ currentAccount, growl }) => {
  const { consumptionId } = useParams();

  const variables = {
    accountId: currentAccount,
    consumptionId,
  };

  return (
    <Query query={VIEWER_LOCALE}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const locale = data && data.viewer ? data.viewer.locale : 'en';

        return (
          <Query query={CONSUMPTION_QUERY} variables={variables}>
            {({ data, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                growlErrors(growl, error);
              }

              return (
                <ConsumptionDetail
                  data={data}
                  currentAccount={currentAccount}
                  locale={locale}
                />
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

ConsumptionDetailContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(withAccount(ConsumptionDetailContainer));
